/**
 * Page header right meta: shows when the dashboard data was last
 * refreshed and a "Live" pulsing dot. Updated by the Analytics page each
 * time it (re)fetches.
 */
import { LiveIndicatorStyles } from "./liveIndicator.styles";

const LiveIndicator = ({ updatedAt }) => {
  const formatted = updatedAt
    ? new Date(updatedAt).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit"
      })
    : "—";

  return (
    <LiveIndicatorStyles>
      <div className="meta-row">
        <span className="meta-label">Updated</span>
        <span className="meta-value">{formatted}</span>
      </div>
      <div className="meta-row">
        <span className="meta-label">Service</span>
        <span className="meta-status">
          <i aria-hidden="true" />
          Live
        </span>
      </div>
    </LiveIndicatorStyles>
  );
};

export default LiveIndicator;
